<template>
  <div>
    <h3 class="heading-3">{{ title }}</h3>
    <div v-if="subtitle" class="body-2">{{ subtitle }}</div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ title: string; subtitle?: string }>()
</script>
